import React, { Component } from "react";
import { compose } from "redux";
import { withTimezone } from "../../components/Timezone";
import TimezoneList from "../../components/TimezoneList";
import FullBtn from "../../components/Buttons/Full";
import s from "./index.css";

const Timezone = ({
  timezone,
  changed,
  timestamp,
  saveTimezone,
  updateTimezone
}) => (
  <div className={s.content}>
    <p className="bold m-0 p-2 font-18">Change your time</p>
    <TimezoneList
      style={{ height: "calc(100% - 114px)" }}
      timezone={timezone}
      timestamp={timestamp}
      updateTimezone={updateTimezone}
    />
    <FullBtn
      fontSize={18}
      className="position-absolute bg-blue text-white text-center py-3 z-index-2 bold"
      style={{ bottom: 0 }}
      disabled={!changed}
      onClick={saveTimezone}
    >
      Save
    </FullBtn>
  </div>
);

export default compose(withTimezone)(Timezone);



// WEBPACK FOOTER //
// ./src/routes/Timezone/Timezone.js